import { IState } from '../../store';

export const selectABGroup = (state: IState) => state.abGroup;
